(function(){
  // Mobile mega menu toggle
  if (window.innerWidth > 768) return;
  document.querySelectorAll('.lc-nav__item > button.lc-nav__link').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var item = btn.closest('.lc-nav__item');
      var mega = item.querySelector('.lc-mega');
      if (!mega) return;
      var isOpen = item.classList.contains('lc-nav__item--open');
      // Close all
      document.querySelectorAll('.lc-nav__item--open').forEach(function(el) {
        el.classList.remove('lc-nav__item--open');
        var openBtn = el.querySelector('button.lc-nav__link');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('lc-nav__item--open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();

(function(){
  var toggle = document.getElementById('lc-search-toggle');
  var panel  = document.getElementById('lc-search-mobile');
  var input  = document.getElementById('lc-search-mobile-input');
  if (!toggle || !panel) return;
  toggle.addEventListener('click', function(){
    var open = panel.getAttribute('aria-hidden') === 'false';
    panel.setAttribute('aria-hidden', open ? 'true' : 'false');
    if (!open && input) setTimeout(function(){ input.focus(); }, 50);
  });
  document.addEventListener('click', function(e){
    if (!toggle.contains(e.target) && !panel.contains(e.target)){
      panel.setAttribute('aria-hidden', 'true');
    }
  });
})();
